import React from 'react';
import PropTypes from 'prop-types';
import { Message } from 'mage-i18n';

import { AlertBannerError } from '@klarna/bubble-ui';

const styles = {
  container: {
    position: 'fixed',
    cursor: 'pointer',
    top: 230,
    right: 60,
    zIndex: 1,
    textAlign: 'right',
  },
  wrapper: {
    borderRadius: 3,
    overflow: 'hidden',
    display: 'inline-block',
    maxWidth: 500,
    wordWrap: 'break-word',
  },
};

const Error = ({ onClick, message = null }) => (
  <div style={styles.container} onClick={onClick}>
    <div style={styles.wrapper}>
      <AlertBannerError icon content={message || <Message path="products-fe.errors.general" />} />
    </div>
  </div>
);

Error.propTypes = {
  onClick: PropTypes.func.isRequired,
  message: PropTypes.string,
};

export default Error;
